import React, { useRef, useEffect, useState } from 'react';
import ServiceCard from './ServiceCard';
import { useScrollReveal } from '../hooks/useScrollReveal';
import { useMediaQuery } from '../hooks/useMediaQuery';
import '../styles/services.css';

const services = [
  {
    title: 'Pushing the frontier',
    description: 'Leveraged prediction markets. New social trading primitives. On-chain AMM and CLOB as white-label solutions.',
  },
  {
    title: 'Risk Management',
    description: 'Stress testing. Portfolio analytics. Model risk management.',
  },
  {
    title: 'Financial Engineering',
    description: 'Applying derivative pricing theory to DeFi and developing new financial primitives.',
  },
  {
    title: 'Analytics',
    description: 'Provide analytics data and risk indicators to power your needs.',
  },
];

function Services() {
  const sectionRef = useRef(null);
  const panelRefs = useRef([]);
  const isMobile = useMediaQuery('(max-width: 768px)');
  const [activeIndex, setActiveIndex] = useState(null);

  useScrollReveal(sectionRef);

  // Mobile: IntersectionObserver for active panel
  useEffect(() => {
    if (!isMobile) {
      setActiveIndex(null);
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const index = panelRefs.current.indexOf(entry.target);
          if (entry.isIntersecting) {
            setActiveIndex(index);
          } else if (activeIndex === index) {
            setActiveIndex(null);
          }
        });
      },
      { threshold: 0.5 }
    );

    const currentRefs = panelRefs.current;
    currentRefs.forEach((ref) => {
      if (ref) observer.observe(ref);
    });

    return () => {
      currentRefs.forEach((ref) => {
        if (ref) observer.unobserve(ref);
      });
    };
  }, [isMobile, activeIndex]);

  return (
    <section className="services" ref={sectionRef}>
      <div className="services-header reveal">
        <p className="services-label">What we build</p>
        <h2 className="services-headline">Frontier infrastructure<br />for decentralized finance</h2>
      </div>
      <div className="services-panels">
        {services.map((service, index) => (
          <div
            key={service.title}
            ref={(el) => { panelRefs.current[index] = el; }}
            className="reveal"
            style={{ transitionDelay: `${index * 150}ms` }}
          >
            <ServiceCard
              number={String(index + 1).padStart(2, '0')}
              title={service.title}
              description={service.description}
              isActive={isMobile && activeIndex === index}
            />
          </div>
        ))}
      </div>
    </section>
  );
}

export default Services;
